import React, { PureComponent } from 'react'
import { injectIntl, FormattedHTMLMessage } from 'react-intl'
import classnames from 'classnames'

import { scrollTo } from './services/utils'

import { IdentificationIcon, StudentIcon, RoomIcon, PhoneIcon } from './Icons'

import './Identification.css'

const icons = {
  firstname: <StudentIcon className="cm-identification--icon" />,
  lastname: <StudentIcon className="cm-identification--icon" />,
  room: <RoomIcon className="cm-identification--icon" />,
  phone: <PhoneIcon className="cm-identification--icon" />
}

const Textfield = injectIntl(
  class Textfield extends PureComponent {
    textUpdated = name => e => {
      const { textfieldChanged } = this.props
      const target = e.target
      const value = target.value
      textfieldChanged(name, value)
    }

    render() {
      const { intl, name, identification, type } = this.props
      const { value, error } = identification[name]
      const classes = classnames('cm-identification--error', {
        'cm-identification--error__visible': error !== undefined
      })
      return (
        <div
          className={`cm-identification--textfield cm-identification--${name}`}
        >
          {icons[name]}
          <input
            type={type !== undefined ? type : 'text'}
            name={name}
            value={value}
            onChange={this.textUpdated(name)}
            placeholder={intl.messages[name]}
            className="disableAutoComplete"
          />
          <span className={classes}>
            {intl.messages.errors.validation[error]}
          </span>
        </div>
      )
    }
  }
)

export default class Identification extends PureComponent {
  isValid() {
    const { identification } = this.props
    return Object.keys(identification).reduce(
      (acc, name) => acc && identification[name].error === undefined,
      true
    )
  }
  componentDidMount() {
    if (document.getElementsByTagName) {
      var inputElements = document.getElementsByTagName('input')
      Array.prototype.slice.call(inputElements).forEach(element => {
        if (
          element.className &&
          element.className.indexOf('disableAutoComplete') !== -1
        ) {
          element.setAttribute('autocomplete', 'off')
        }
      })
    }
  }
  componentDidUpdate(prevProps) {
    if (!this.isValid()) {
      scrollTo(this.element)
    }
  }
  render() {
    return (
      <div ref={el => (this.element = el)} className="cm-identification--outer">
        <div className="cm-identification--title">
          <IdentificationIcon className="cm-identification--picto" />
          <FormattedHTMLMessage id="student_identification" />
        </div>
        <form className="cm-identification">
          <Textfield name="firstname" {...this.props} />
          <Textfield name="lastname" {...this.props} />
          <Textfield name="room" {...this.props} />
          <Textfield name="phone" {...this.props} type="tel" />
        </form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Identification.js